// components/ui/profile-avatar.tsx
import * as React from "react";
import { cn } from "@/lib/utils"; // Assuming you have a utility for class concatenation
import { User2 } from "lucide-react"; // Default icon

// Define the types for the component's props
interface ProfileAvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  profileImageUrl?: string | null; // Optional URL for the profile image
}

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({
  profileImageUrl,
  className,
  ...props
}) => {
  return (
    <div
      className={cn(
        "relative h-10 w-10 lg:h-12 lg:w-12 rounded-lg flex items-center justify-center flex-shrink-0",
        className,
      )}
      {...props}
    >
      {profileImageUrl ? (
        <img
          src={profileImageUrl}
          alt="Profile"
          className="h-full w-full object-cover rounded-lg"
        />
      ) : (
        <>
          {/* Default gradient background for fallback */}
          <div className="absolute inset-0 rounded-lg bg-gradient-to-br from-cyan-400 to-blue-500"></div>
          {/* Default icon */}
          <User2 className="h-5 w-5 lg:h-6 lg:w-6 text-slate-900 z-10" />
          {/* Pulse animation for fallback */}
          <div className="absolute inset-0 rounded-lg bg-cyan-400/20 animate-pulse"></div>
        </>
      )}
    </div>
  );
};

export { ProfileAvatar };
